import React, { useEffect, useState } from "react";
// styles
import classes from "./dashboard.module.scss";
// assets
import Ventas from '../../assets/icons/ventas.svg';
import PorCobrar from '../../assets/icons/por-cobrar.svg';
// components
import Card from "../../components/utils/cards/Card";
import Saldos from "../../components/utils/cards/Saldos";
import Solicitudes from "../../components/utils/cards/Solicitudes";
// Recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from '../../recoilState/GlobalState'
import { Routes } from "../../consts/Routes-App";
import {
    MWDashboardVentasGet, MWDashboardPorCobrarGet, MWDashboardSaldosGet
} from "../../services/hooli-services";

export default function Dashboard() {
    const [ventasHoy, setVentasHoy] = useState({ H: { monto: 0, operaciones: 0 }, C: { monto: 0, operaciones: 0 }, D: { monto: 0, operaciones: 0 }, B: { monto: 0, operaciones: 0 }, T: { monto: 0, operaciones: 0 } });
    const [ventasSemana, setVentasSemana] = useState({});
    const [cobrarHoy, setCobrarHoy] = useState({ H: { monto: 0, operaciones: 0 }, C: { monto: 0, operaciones: 0 }, D: { monto: 0, operaciones: 0 }, B: { monto: 0, operaciones: 0 }, T: { monto: 0, operaciones: 0 } });
    const [cobrarFuturo, setCobrarFuturo] = useState([{ H: { monto: 0, operaciones: 0 }, C: { monto: 0, operaciones: 0 }, D: { monto: 0, operaciones: 0 }, B: { monto: 0, operaciones: 0 }, T: { monto: 0, operaciones: 0 } }]);
    const [totales, setTotales] = useState({});
    const [ultimoMovimiento, setUltimoMovimiento] = useState({});
    const [cargando, setCargando] = useState(true);
    const [ventasDia, setVentasDia] = useState({});
    const [porAcreditar, setPorAcreditar] = useState({});
    const [data, setData] = useState({});
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    
    const ventasDelDiaGet = async() => {
        const data = await MWDashboardVentasGet(credentials);
        setVentasSemana(data)
        const fechaMaxima = data?.reduce((max, t) =>
            t.posTransaccionFecha > max ? t.posTransaccionFecha : max,
            data[0]?.posTransaccionFecha
        );
        const dataHoy = data?.filter((t) => t.posTransaccionFecha === fechaMaxima)
        // console.log(dataHoy)
        const dataH = dataHoy?.filter((mov) => mov.posTransaccionMetodoPago === "H")
        const dataR = dataHoy?.filter((mov) => mov.posTransaccionMetodoPago === "R")
        const dataC = dataHoy?.filter((mov) => mov.posTransaccionMetodoPago === "C")
        const dataD = dataHoy?.filter((mov) => mov.posTransaccionMetodoPago === "D")
        const formatDia = data[0] && data?.map(item => {
            return {
                dataTotal: dataHoy?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadTotal: dataHoy?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoTotalArs: dataH?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadArs: dataH?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoCreditos: dataR?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadCreditos: dataR?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoCredito: dataC?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadCredito: dataC?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoDebito: dataD?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadDebito: dataD?.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
            }
        })
        setVentasDia(formatDia)
    }

    const ventasPorAcreditarGet = async() => {
        const data = await MWDashboardPorCobrarGet(credentials)
        const dataH = data.filter((mov) => mov.posTransaccionMetodoPago === "H")
        const dataR = data.filter((mov) => mov.posTransaccionMetodoPago === "R")
        const formatAcreditar = data[0] && data?.map(item => {
            return {
                dataTotal: data.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadTotal: data.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoTotalArs: dataH.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadArs: dataH.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
                montoCreditos: dataR.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionMontoTotal,
                        0
                    ),
                cantidadCreditos: dataR.reduce(
                    (acumulador, transaccion) => acumulador + transaccion.posTransaccionOperaciones,
                        0
                    ),
            }
        })
        setPorAcreditar(formatAcreditar)
    }

    const saldosGet = async() => {
        const responseSaldo = await MWDashboardSaldosGet(credentials);
        setTotales(responseSaldo)
    }

    const getInfo = async() => {
        if(credentials.merchantId){
            Promise.all([ventasDelDiaGet(), ventasPorAcreditarGet(), saldosGet()]).then(() => {
                setCargando(false)
            })
        }
    }
    useEffect(() => {
        getInfo()
    }, [credentials]);
    useEffect(() => {
        setRoute(Routes[window.location.pathname.split('/')[1]])
    }, []);
    
    return (
        <main className={classes.main}>
            {credentials.rolCod !== "ME" && <div className={classes.container}>
                <div className={classes.cards}>
                    <Card
                        type="ventas"
                        dataHoy={ventasHoy}
                        dataSerie={ventasSemana}
                        totales={ventasDia[0]}
                        title="Ventas del día"
                        detail="(Operaciones completadas)"
                        link="/ventas"
                        image={Ventas}
                        cargando={cargando}
                    />
                    <Card
                        type="acreditar"
                        dataHoy={cobrarHoy}
                        dataSerie={cobrarFuturo}
                        totales={porAcreditar}
                        title="Por acreditar"
                        link="/aCobrar"
                        image={PorCobrar}
                        cargando={cargando}
                        ultimoMovimiento={ultimoMovimiento}
                    />
                    <Saldos totales={totales} cargando={cargando} />
                    <Solicitudes data={""} cargando={cargando} />
                </div>
            </div>
            }
        </main>
    );
};
